var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bag", on: { click: _vm.chilkHandle } }, [
    !_vm.showOpen
      ? _c("img", {
          attrs: { src: require("@/assets/chou/r.png"), alt: "", srcset: "" },
        })
      : _c("img", {
          attrs: { src: require("@/assets/chou/t.png"), alt: "", srcset: "" },
        }),
    _c("div", { ref: "box", staticClass: "start" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }